const isMainTheme = Shopify.theme.role === "main";

const sampleRate = isMainTheme ? 0.05 : 0;
const tracesSampleRate = isMainTheme ? 0.05 : 0;

const environment =
  Shopify.shop === "tannico-prod.myshopify.com" ? "production" : "staging";

const ignoredPatterns = [
  "shopifysvc.com",
  "eu1-api.doofinder.com",
  "eu1-recommendations.doofinder.com",
  "api.tapc.art",
  "cdn.shopify.com",
  "web-pixels.shopifyapps.com",
  "/web-pixels/",
  "/shopifycloud/shop-js/",
  "chrome-extension://",
  "moz-extension://",
  "safari-extension://",
];

const ignoreErrors = [
  /^ResizeObserver loop limit exceeded$/,
  /^Script error\.?$/,
  /^An event processor returned `null`, will not send event\.$/,
  "realDefault", // Ignore heres error
];

window.sentryOnLoad = function () {
  Sentry.init({
    release: `${Shopify.theme.name}@${Shopify.theme.id}`,
    tracesSampleRate,
    sampleRate,
    ignoreErrors,
    environment,
    beforeSend(event, hint) {
      //const originalError = hint?.originalException;
      const message =
        event?.message || event?.exception?.values?.[0]?.value || "";

      const frames = event?.exception?.values?.[0]?.stacktrace?.frames || [];

      const breadcrumbs = event?.breadcrumbs || [];

      // Flatten everything searchable
      const eventText = [
        message,
        ...frames.map((f) => f.filename || ""),
        ...breadcrumbs.map((b) => b.data?.url || ""),
      ].join(" ");

      // Ignore noisy third-party/browser/shopify errors
      if (ignoredPatterns.some((pattern) => eventText.includes(pattern))) {
        return null;
      }

      // Ignore generic network noise
      const isLoadFailed = /Load failed|Failed to fetch|NetworkError/i.test(
        message,
      );

      if (isLoadFailed) {
        const importantRequest = [
          "/cart/",
          "/recommendations/",
          "/search/suggest",
          "?sections=",
          "/products/",
          "/collections/",
        ].some((path) => eventText.includes(path));

        if (!importantRequest) {
          return null;
        }
      }

      event.tags = {
        ...event.tags,
        theme_role: Shopify.theme.role,
        shop: Shopify.shop,
        template: document.body?.dataset?.template || "unknown",
      };

      return event;
    },
  });
};
